import { render, staticRenderFns } from "./qjyl.vue?vue&type=template&id=4958f940&scoped=true"
import script from "./qjyl.vue?vue&type=script&lang=js"
export * from "./qjyl.vue?vue&type=script&lang=js"
import style0 from "./qjyl.vue?vue&type=style&index=0&id=4958f940&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958f940",
  null
  
)

export default component.exports